import trendUpdates from './trend-updates'
import updateInfo from './update-info'

export default {
    trendUpdates,
    updateInfo
}
